import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../src/helpers/reselectHelpers';
import {
  createContactFormUpdateAccessAction,
  createContactFormUpdateAccountAction,
  createContactFormUpdateAvatarFileAction,
  createContactFormUpdateDescriptionAction,
  createContactFormUpdateNameAction,
} from '../../../../../../../src/store/panels/contacts/createContactForm/createContactFormActions';
import {ContactsManagerPanelId} from '../../../../../../../src/store/panels/panelStateBase';
import {CreateContactForm} from './createContactForm';

/*
 * Props.
 */

interface CreateContactFormContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateContactFormContainerProps>()((props) => ({
  onUpdateName: (name: string) => createContactFormUpdateNameAction(props.panelId, name),
  onUpdateDescription: (description: string) =>
    createContactFormUpdateDescriptionAction(props.panelId, description),
  onUpdateAvatarFile: (file: File) => createContactFormUpdateAvatarFileAction(props.panelId, file),
  onUpdateAccess: (access: string) => createContactFormUpdateAccessAction(props.panelId, access),
  onUpdateAccount: (accountId: number) => createContactFormUpdateAccountAction(props.panelId, accountId),
}));

export const CreateContactFormContainer = connect(null, mapDispatchToProps)(CreateContactForm);
